import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import MbRadio from 'components/atoms/MbRadio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = makeStyles((theme) => ({
  radioGroup: {
    flexDirection: 'row',
    padding: '6px',
  },
  formControlLabel: {
    marginLeft: 0,
  },
  error: {
    borderBottom: '1px solid red',
  },
  helper: {
    fontSize: '.75rem',
    margin: '5px 14px 0',
    color: theme.palette.common.red,
  },
}));

const CheckboxGroup = (props) => {
  const {
    name,
    optionList = [],
    params,
    handleGetValue = (f, name) => f,
    style = {},
    error = false,
    helperText = null,
  } = props;
  const classes = styles();

  /**
   * @param value
   * 체크박스를 클릭했을때 실행되는 함수
   * checkArray에 담아뒀다가 params값이랑 같이 부모 컴포넌트에 전달
   */
  const handleOnClick = (props, value) => {
    const newParams = {
      ...params,
      [name]: value,
    };
    handleGetValue(newParams, name);
  };

  const makeRadioList = (props) => {
    const { labelKey, valueKey } = props;
    let radioList = [];

    for (let i = 0; i < optionList.length; i++) {
      radioList.push(
        <FormControlLabel
          key={optionList[i][labelKey]}
          label={optionList[i][labelKey]}
          value={optionList[i][valueKey]}
          onClick={() => handleOnClick(props, optionList[i][valueKey])}
          control={<MbRadio color="primary" />}
          classes={{ root: classes.formControlLabel }}
          style={style}
        />
      );
    }
    return radioList;
  };

  return (
    <>
      <RadioGroup
        name={name}
        value={typeof params[name] !== 'undefined' && params[name]}
        className={clsx(error && classes.error)}
        classes={{ root: classes.radioGroup }}
      >
        {optionList.length > 0 && makeRadioList(props)}
      </RadioGroup>
      {!!helperText && <p className={classes.helper}>{helperText}</p>}
    </>
  );
};

export default CheckboxGroup;
